// import { useDispatch, useSelector } from "react-redux";
// import { showSnackBar } from "../../utils/commonServices";
// import {  watchVideoApi } from "../../services/api";




// export default ()=> {
 
//   const dispatch = useDispatch();
//   const commonReducer = useSelector(state=> state.root.commonReducer)
 

//       const uploadFile = (file, chunk, chunkIndex ) => {

//         const formData = new FormData();
//         formData.append('file', chunk, `${file.name}.part${chunkIndex}`);
      
//         // Simulating an API call
//         return new Promise((resolve) => {
//           setTimeout(() => {
//             console.log(`Uploaded chunk ${chunkIndex} of ${file.name}`);
//             resolve();
//           }, 500); // Simulated delay
//         });
//         // watchVideoApi() 
//         // .then((response) => {
//         //   if(response?.data?.http_code === 200){
           
//         //   }
//         // })
//         // .catch((error) => {
        
//         //  if(error) {
//         //   const errorObject = error?.response?.data;
//         //   showSnackBar(dispatch, errorObject);
        
//         // }
//         // });
//       }


//   return { uploadFile};
// }


import { useDispatch, useSelector } from "react-redux";
import { showSnackBar } from "../../utils/commonServices";
import { uploadChunkApi, uploadChunkPostFlightApi, uploadChunkPostFlightGuestApi, uploadChunkPreflightApi, uploadChunkPreflightGuestApi, uploadList, } from "../../services/api";
import { useState } from "react";
import { setUploadState } from "../../redux/uploadSlice";
import { useQueryClient } from "react-query";

export default () => {
  const dispatch = useDispatch();
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const [mediaId, setMediaId] = useState()
  const queryClient = useQueryClient();

  

  const fileUploadPreflight = async (value, isGuest, callback ) => {
  
    // uploadChunkPreflightApi(payload) 
    // .then((response) => {
    //   if(response?.data?.http_code === 200){
    //    console.log('preflight response', response?.data?.data?.id)
    //    setMediaId(response?.data?.data?.id)
    //   // callback(response?.data?.data?.id)
    //    return response?.data?.data?.id
    //  }
    // })
    // .catch((error) => {
    //  if(error) {
    //   const errorObject = error?.response?.data;
    //   showSnackBar(dispatch, errorObject);
    // }
    // });
    try {
      const response = isGuest ? await uploadChunkPreflightGuestApi(value) : await uploadChunkPreflightApi(value) ;
      if (response?.data?.http_code === 200) {
        console.log('preflight response', response?.data?.data?.id);
        return response?.data?.data?.id;  // This will now correctly return to the outer function
      } else {
        throw new Error('Unexpected response code');
      }
    } catch (error) {
      console.error('Error during preflight:', error?.response?.data || error.message);
      throw error;  // Ensure the calling function knows there was an error
    }
  }
  const fileUploadPostflight = async (value, isGuest,  callback) => {
    try {
      const response = isGuest ? await uploadChunkPostFlightGuestApi(value) : await uploadChunkPostFlightApi(value) ;
        dispatch(setUploadState({ uploading_file_index: null }));
      if (response?.data?.http_code === 200) {
        console.log('postflight response', response?.data);
        callback(0)
        // Trigger a fresh fetch of the upload list so UI can update immediately
        if (commonReducer?.production_event_id) {
          queryClient
            .fetchQuery(
              [`uploadList${commonReducer.production_event_id}`, commonReducer.production_event_id],
              () => uploadList({ id: commonReducer.production_event_id })
            )
            .catch(() => {});
        }
        // You can invoke the callback here if needed
        // callback(response?.data?.data?.id);
      }
    } catch (error) {
      const status = error?.response?.status;
      const errorData = error?.response?.data;
      const errorCode = errorData?.error_code;
      const message = errorData?.message;

      // These are decided BEFORE the 422 handler below, which maps every 422 to
      // "chunks are missing". A coded 409 or a 503 is not a missing-chunk signal
      // and must not be swallowed by it.
      if (status === 409) {
        // upload_corrupt: every part arrived but the sizes do not add up. The
        // server has already aborted the upload, so the only way forward is a
        // fresh pre_flight - never the re-upload loop.
        const type = errorCode === 'upload_corrupt' ? 'UPLOAD_CORRUPT' : 'STOP_FILE';
        throw { type, errorCode, httpStatus: status, message };
      }

      // Storage was briefly unavailable, or the finish failed server-side. The
      // chunks are all still there; only post_flight needs repeating.
      if (status === 503 || status === 500) {
        throw { type: 'RETRY_POSTFLIGHT', errorCode, httpStatus: status, message };
      }

      // Identity, permission and "not found" are terminal for this file.
      if (status === 403 || status === 404) {
        throw { type: 'STOP_FILE', errorCode, httpStatus: status, message };
      }

      if (status === 422) {
        // The missing-chunk body is the only 422 the re-upload loop reacts to,
        // and its array is never empty. Anything else 422 stops the file.
        const missing = errorData?.missing_chunk_indices;
        if (Array.isArray(missing) && missing.length > 0) {
          throw { type: 'MISSING_CHUNKS', missing_chunk_indices: missing };
        }
        throw { type: 'STOP_FILE', errorCode, httpStatus: status, message };
      }

      console.error('Error:', error);
      throw error; // rethrow so the caller can set the correct error status
    }
  };

  const uploadFile = async (file, chunk, chunkIndex, fileIndex, payloadData) => {
    const formData = new FormData();
    formData.append('file', chunk, `${file.name}.part${chunkIndex}`);

    // // Simulating an API call with file_index as file_id
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     // Log with the required object format
    //     const logObject = {
    //       file_id: fileIndex,   // Use fileIndex as the file_id
    //       chunk_id: chunkIndex,
    //       file_name: file.name,
    //       chunk:chunk
    //     };
    //     console.log(`Uploaded chunk ${chunkIndex} of ${file.name}`, logObject);

    //     resolve();
    //   }, 500); // Simulated delay
    // });

    // Uncomment and adjust if using actual API
    const payload = {
      ...payloadData,
      media_file_id: mediaId
    }
    uploadChunkApi(payload)
      .then((response) => {
        console.log('api call')
        if (response?.data?.http_code === 200) {
          console.log("Success");
        }
      })
      .catch((error) => {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      });
  };


 

  return { uploadFile, fileUploadPreflight , fileUploadPostflight};
};
